import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function ForbiddenPage() {
  return (
    <>
      <SeoHead
        title="Adgang nægtet (403)"
        description="Du har ikke adgang til den anmodede ressource. Gå tilbage til forsiden."
      />

      <section className="min-h-[80vh] flex items-center justify-center pt-32 pb-20 bg-[#FAF8F5]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center space-y-8">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#EAE4DC] text-xs font-bold uppercase tracking-widest text-[#4A4640]">
            <span>Fejl 403</span>
          </div>

          <div className="space-y-3">
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#161514]">
              Adgang nægtet
            </h1>
            <p className="text-base sm:text-lg text-[#5C5852] max-w-lg mx-auto leading-relaxed">
              Du har desværre ikke rettigheder til at tilgå denne side eller ressource.
            </p>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#161514] text-white font-semibold text-sm hover:bg-[#2A2926] transition-colors shadow-xs"
            >
              <i className="fa-regular fa-arrow-left text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#EAE4DC] text-[#161514] font-semibold text-sm hover:bg-[#DDD6CC] transition-colors"
            >
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
